/**
 * Guide Page contact Pill
 */
var ContactUsPill = (function () {
  var isContactPill = document.querySelector(".contact-pill");

  function init() {
    if (
      isContactPill &&
      Cookie.read("show_freshchat") != 1 &&
      window.innerWidth >= 980
    ) {
      /*
       * WebEventTracker Event for Contact Us Pill OnLoad
       * SetInterval require because contact pill show classes added from VWO so its missed load event from experiment
       */
      var LoadContactPillTimer = setInterval(function () {
        if (isContactPill.classList.contains("contact-pill__show")) {
          // Onload ContactPill Event
          if (window.hasOwnProperty("WebEventTracker")) {
            WebEventTracker.logEvent("", "LoadContactPill", {
              Source: window.location.href,
            });
          }
          clearInterval(LoadContactPillTimer);
        }
      }, 500);

      /* WebEventTracker Event for Contact Us Pill When clicked */
      document
        .getElementById("contact-pill__link")
        .addEventListener("click", function (evt) {
          WebEventTracker.logEvent("", "ClickedContactPill", {
            Source: window.location.href,
          });
        });

      // Show contact pill on scroll
      window.addEventListener("scroll", function () {
        var scroll = window.pageYOffset;
        var headerHeight =
          document.getElementById("header-habitat").offsetHeight - 63;

        if (scroll <= headerHeight) {
          setTimeout(function () {
            isContactPill.style.bottom = "-100px";
          }, 150);
        } else {
          setTimeout(function () {
            isContactPill.style.bottom = "0px";
          }, 100);
        }
      });
    }
  }

  return {
    init: init,
  };
})();

//Call ContactUsPill
window.addEventListener("load", function () {
  ContactUsPill.init();
});
window.addEventListener("resize", function () {
  ContactUsPill.init();
});
